import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import Main_Winter from '../../component/Winter/Main_Winter';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../../component/Fall/Info_Fall';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import CallInfo from '../../component/CallInfo';
import ParentInfo from '../../component/Info/ParentInfo';
import Information from '../../component/Information';

const YuMiJung = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "양병학🤍유미정 결혼합니다.";
    const openDesc = "12월 6일 토요일 오후 1시 30분 \n더케이웨딩컨벤 수원 2층 단독홀";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/271/thumb.jpg";

    const lng = 127.03306513522458;
    const lat = 37.26338981995204;
    
    const placeTelNum = "031-224-2030";

    const forBus = "지선(씨티은행 하차) 13-1, 92, 92-1, 99-2, 202, 201\n광역(씨티은행 하차) 3002, 7002, 4000\n지선(수원시청역 하차) 80, 51, 61, 81, 82-1. 85\n광역(수원시청역 하차) 4000, 7002"
    const forCar = "네비게이션에 '더케이웨딩컨벤션'을 입력해주세요.\n주차는 2시간 무료, 부족시 근처 건물로 안내해드립니다."
    const forSubway = "수인분당선 수원시청역 9번출구 도보 2분\n8번 출구 대각선 방향 길 건너 도보 3분"
    const desc = "웨딩홀은 2층, 연회장은 15층입니다."


    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        concept: "WINTER",
        titleColor: "#000000",
        pointColor: "#000000",
        btnBgColor: "#000000",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F4F4F4",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }


    const parents = [
        {groom : "박상윤 · 김미영의 장남"},
        {bride : "김명광 · 이명자의 장녀"}
    ]

    const parentInfo = {
        groom: {
            dad: { name: "최종국", isDeceased: false },
            mom: { name: "김복희", isDeceased: false },
            role: "차남",
        },
        bride: {
            dad: { name: "박민규", isDeceased: false },
            mom: { name: "안혜자", isDeceased: false },
            role: "장녀",
        }
    };

    const title = "소중한 분들을 초대합니다."

    const msg1 = "서로에게 행복을 주는 사람을 만났습니다.";
    const msg2 = "웃는 모습이 너무나 예쁜 그 사람을 만났습니다.\n배려하는 마음이 따뜻한 그 사람을 만났습니다.";
    const msg3 = "운명처럼 만나게 된 우리의 인연,\n그 인연에 이끌려\n이제 영원을 함께 약속하려 합니다."
    const msg4 = "따뜻한 발걸음과 축복으로\n자리를 빛내주시면\n더없는 기쁨으로 간직하겠습니다.\n\n"


    const groomAccountList = [
        {
            role: "신랑",
            name: "양병학",
            bank: "국민은행",
            accountNumber : "240802-04-333621",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "양환식",
            bank: "카카오뱅크",
            accountNumber : "3333-12-1563812",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "박혜란",
            bank: "농협은행",
            accountNumber : "207014-52-072934",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "유미정",
            bank: "신한은행",
            accountNumber : "110-531-114496",
            isKakao :false
        }
        ,{
            role: "신부 부",
            name: "유인호",
            bank: "신한은행",
            accountNumber : "518-04-316155",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "오선양",
            bank: "기업은행",
            accountNumber : "010-3466-6820",
            isKakao : false
        }
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "이민혁",
            call: "010-4150-8836"
        }
        ,{
            role: "신랑 부",
            name: "이병훈",
            call: "010-5498-5558"
        }
        ,{
            role: "신랑 모",
            name: "황지윤",
            call: "010-5169-8836"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "최정아",
            call: "010-7125-5987"
        }
        ,{
            role: "신부 부",
            name: "최병일",
            call: "010-5483-6218"
        }
        ,{
            role: "신부 모",
            name: "이경숙",
            call: "010-3722-6218"
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "어머 얘좀 봐",
            brideAnswer: "아직도 생생해"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "두번은 못해",
            brideAnswer: "떨리고 좋아"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "사랑해, 평생",
            brideAnswer: "행복하자♥♥"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "잘 살아보자",
            brideAnswer: "밥 잘해줄게"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "축하해줘요",
            brideAnswer: "많이많이♥"
        }
    ]

    const informationList =[
        {
            title : "피로연 안내",
            content : "날짜 7월 10일 오전 11시 ~ 오후 3시\n장소 충남 태안군 안면읍 백사장 1길 91\n진미각 중화요리"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#000000"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Winter width={"300px"} weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstNameEn(weddingData.brideNameEn)} groomNameEn={getFirstNameEn(weddingData.groomNameEn)} />
                    <Save_Date_Fall weddingData={weddingData} color={conceptStyle.titleColor} />
                    <Info_Fall  conceptStyle={conceptStyle} weddingData={weddingData} />
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} msg4={msg4} conceptStyle={conceptStyle} />
                    {/* <CallInfo marginTop={"0px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper>  */}
                    <Dday_Spring groomName={getFirstKoName(weddingData.brideName)} brideName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring  weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    </MotionWrapper>
                    {/* <Information conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <MotionWrapper initialY={50}>
                        <Location_Spring  weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc forCar={forCar} forBus={forBus} forSubway={forSubway} desc={desc} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default YuMiJung;